import dayjs from 'dayjs';

const Business = class Business {
    constructor() {
        this.id = null;
        this.name = '';
        this.owner = {
            email: '',
            fullName: '',
            phone: ''
        };
        this.domain = '';
        this.maxUsers = null;
        this.isActive = true;
        this.isChallenge = false;
        this.definitions = {
            sessions: [],
            emails: [],
            program: {
                startedAt: dayjs().format('YYYY-MM-DD'),
                endedAt: dayjs()
                    .add(30, 'day')
                    .format('YYYY-MM-DD')
            }
        };
    }
};

export default Business;
